import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { BASE_URL, ITEMS_PER_PAGE } from "../config";
import "./Blog.css";
import Footer from "../Home/Footer";

const BlogCard = ({ id, image, title, admin, date, relativeDate, onClick }) => {
  return (
    <div className="blog-card" onClick={onClick} data-id={id}>
      <img src={image} alt={title} className="blog-image" />
      <h6 className="blog-title">{title}</h6>
      <div className="blog-info">
        <span className="admin">👤 {admin}</span>
        <span className="date">🗓️ {relativeDate}</span>
      </div>
    </div>
  );
};

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [typedText, setTypedText] = useState("");
  const blogsPerPage = ITEMS_PER_PAGE;
  const navigate = useNavigate();
  const { pageNumber } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (pageNumber) {
      setCurrentPage(Number(pageNumber));
    }
  }, [pageNumber]);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(
        `${BASE_URL}/blogs_ai4bazaar?page=${currentPage}&limit=${blogsPerPage}`
      );
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setBlogs(data.blogs || []);
      setTotalPages(Math.max(1, Math.ceil((data.total || 0) / blogsPerPage)));
    } catch (err) {
      console.error("Failed to fetch blogs", err);
      setError("Failed to load blogs. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, [currentPage]);

  const formatDateDiff = (postDate) => {
    const postDateObj = new Date(postDate);

    if (isNaN(postDateObj)) {
      console.error("Invalid date:", postDate);
      return "Invalid date";
    }

    const today = new Date();
    let diffYear = today.getFullYear() - postDateObj.getFullYear();
    let diffMonth = today.getMonth() - postDateObj.getMonth();

    if (diffMonth < 0) {
      diffMonth += 12;
      diffYear -= 1;
    }

    if (diffMonth === 1 && diffYear === 0) {
      return "1 month ago";
    } else if (diffMonth > 1 && diffYear === 0) {
      return `${diffMonth} months ago`;
    } else if (diffYear === 1) {
      return `1 year ago`;
    } else if (diffYear > 1) {
      return `${diffYear} years ago`;
    }

    const diffTime = today - postDateObj;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    return `${diffDays} days ago`;
  };

  const handleCardClick = (id) => {
    const blog = blogs.find((b) => b.id === id);

    if (!blog) {
      console.error("Blog not found");
      return;
    }

    const relativeDate = formatDateDiff(blog.date);

    navigate(`/blog/${id}`, {
      state: {
        page: currentPage,
        relativeDate: relativeDate,
      },
    });
  };

  const fullText = "OUR BLOGS";
  const typingSpeed = 150;

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setTypedText(fullText.substring(0, index + 1));
      index++;
      if (index === fullText.length) clearInterval(interval);
    }, typingSpeed);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Blog Header */}
      <div>
        
     

      {/* Intro Section */}
      <div className="intro-section">
        <h2 className="intro-title">
          "Insights & Inspiration: Explore Our Journey as We Guide, Innovate, and
          Empower Through Knowledge."
        </h2>
      </div>

      {/* Blog List */}
      <div className="blog-page">
        {loading ? (
          <div className="loading-container">
            <div className="loading-text">Loading blogs...</div>
          </div>
        ) : error ? (
          <div className="error-container">
            <div className="error-text">{error}</div>
            <button className="blog-retry-btn" onClick={fetchBlogs}>Try Again</button>
          </div>
        ) : blogs.length === 0 ? (
          <div className="not-found-container">
            <div className="not-found-text">No blogs found.</div>
          </div>
        ) : (
          <>
            <div className="blog-list-container">
              {blogs.map((blog) => (
                <BlogCard
                  key={blog.id}
                  id={blog.id}
                  image={`${BASE_URL}/blogs_ai4bazaar/${blog.id}/image`}
                  title={blog.title}
                  admin={blog.admin}
                  date={blog.date}
                  relativeDate={formatDateDiff(blog.date)}
                  onClick={() => handleCardClick(blog.id)}
                />
              ))}
            </div>
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  className={`page-button ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/page/${index + 1}`);
                  }}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
       </div>
      <Footer />
    </>
  );
};

export default Blog;
